/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch
 */
export interface FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch
     */
    Name: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch interface.
 */
export function instanceOfFxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch(value: object): value is FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch {
    if (!('Name' in value) || value['Name'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchFromJSON(json: any): FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch {
    return FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchFromJSONTyped(json, false);
}

export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch {
    if (json == null) {
        return json;
    }
    return {
        
        'Name': json['Name'],
    };
}

export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchToJSON(json: any): FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch {
    return FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchToJSONTyped(json, false);
}

export function FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranchToJSONTyped(value?: FxIdWebFeaturesFtlIntegrationLauncherAvailableBranchesBranch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Name': value['Name'],
    };
}

